export const trackMap = {
  落地页_万事达活动: {
    btnId: 'page_master_info',
    btnName: '落地页_万事达活动'
  },
  落地页_Visa活动: { btnId: 'page_visa_info', btnName: '落地页_Visa活动' },
  落地页_万事达卡片: {
    btnId: 'page_master_card',
    btnName: '落地页_万事达卡片'
  },
  落地页_Visa卡片: { btnId: 'page_visa_card', btnName: '落地页_Visa卡片' },
  落地页_更多万事达: {
    btnId: 'page_master_more',
    btnName: '落地页_更多万事达'
  },
  落地页_更多Visa: { btnId: 'page_visa_more', btnName: '落地页_更多Visa' },
  落地页_选择省份: {
    btnId: 'page_select_province',
    btnName: '落地页_选择省份'
  },
  落地页_选择城市: { btnId: 'page_select_city', btnName: '落地页_选择城市' },
  落地页_选择区县: { btnId: 'page_select_site', btnName: '落地页_选择区县' },
  落地页_选择网点: { btnId: 'page_select_bank', btnName: '落地页_选择网点' },
  万事达列表页_世界借记卡: {
    btnId: 'page_master_card1',
    btnName: '万事达列表页_世界借记卡'
  },
  万事达列表页_万事达金卡: {
    btnId: 'page_master_card2',
    btnName: '万事达列表页_万事达金卡'
  },
  万事达列表页_万事达白金卡: {
    btnId: 'page_master_card3',
    btnName: '万事达列表页_万事达白金卡'
  },
  万事达列表页_万事达非人哉卡: {
    btnId: 'page_master_card4',
    btnName: '万事达列表页_万事达非人哉卡'
  },
  VISA列表页_VISA白金卡: {
    btnId: 'page_visa_card1',
    btnName: 'VISA列表页_VISA白金卡'
  },
  VISA列表页_VISA金卡: {
    btnId: 'page_visa_card2',
    btnName: 'VISA列表页_VISA金卡'
  },
  VISA列表页_VISA冬奥黑卡: {
    btnId: 'page_visa_card3',
    btnName: 'VISA列表页_VISA冬奥黑卡'
  },
  VISA列表页_VISA冬奥蓝卡: {
    btnId: 'page_visa_card4',
    btnName: 'VISA列表页_VISA冬奥蓝卡'
  },
  详情_万事达: {
    btnId: 'pagemore_master',
    btnName: '详情_万事达'
  },
  详情_Visa: {
    btnId: 'pagemore_visa',
    btnName: '详情_Visa'
  },
  落地页_汇款优惠: {
    btnId: 'page_money',
    btnName: '落地页_汇款优惠'
  }
};

export function track(item) {
  try {
    console.log('按钮埋点:', item.btnId, item.btnName);
    window.opfStatisticSdk.btnClick(item.btnId, item.btnName);
  } catch (err) {}
}
